export const nonNegative = (fieldName) => ({
  guard: (data) => data[fieldName] === undefined || parseInt(data[fieldName], 10) >= 0,
  msg: 'Negative number'
})